import React from 'react';
import { MeasuredCookieType } from '@wix/da-shared-react/pkg/Measured';
import ItemCard from '../../ItemCard';
import { StandardGrid, GridElement } from '@wix/da-shared-react/pkg/Grid';
import { FacetPageType, FacetItem, Strip } from '../../../../types/api';
import { getItemType, getItemId } from '../../FacetStream';
import Strips from '../../Strips';
import { FOOTER_HEIGHT as COLLECTION_CARD_FOOTER_HEIGHT } from '@wix/da-shared-react/pkg/CollectionCard';
import { PANEL_HEIGHT as COMMISSION_CARD_FOOTER_HEIGHT } from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Shop';
import { getStreamItemId } from '@wix/da-shared-react/pkg/Duperbrowse/redux/helpers';
import { isDeviation } from '../../FacetStream/helper';
import EmptyResult from '../../EmptyResult';

const DEFAULT_STRIP_INDEX = 5;
const STRIP_HEIGHT_MOBILE = 900;
const STRIP_HEIGHT_DESKTOP = 500;

export interface Props {
  items: FacetItem[];
  pageType: FacetPageType;
  isMobile?: boolean;
  strips?: Strip[];
  contentStrip?: React.ReactNode;
  contentStripIndex?: number;
  contentStripHeight?: number;
  isInfiniteScroll?: boolean;
  onOffsetReached?: (offset: number) => void;
}

export class BrowseGrid extends React.Component<Props> {
  render() {
    if (!this.props.items || !this.props.items.length) {
      return <EmptyResult />;
    }

    return (
      <StandardGrid
        {...this.getStripProps()}
        elementCount={this.props.items.length}
        cookieType={MeasuredCookieType.BROWSE}
        getElementId={this.getGridItemId}
        getDuperbrowseItemId={this.getDuperbrowseItemId}
        adjustHeight={this.adjustCardHeightForPageType()}
        enableScrollOptim={this.props.isInfiniteScroll}
        onOffsetReached={
          this.props.isInfiniteScroll ? this.props.onOffsetReached : undefined
        }
      >
        {this.renderGridItem}
      </StandardGrid>
    );
  }

  getStripProps() {
    const {
      isMobile,
      strips = [],
      contentStrip = strips.length ? <Strips /> : null,
      contentStripIndex = DEFAULT_STRIP_INDEX,
      contentStripHeight = isMobile
        ? STRIP_HEIGHT_MOBILE
        : STRIP_HEIGHT_DESKTOP,
    } = this.props;
    return contentStrip
      ? {
          contentStrip,
          contentStripIndex,
          contentStripHeight,
        }
      : {};
  }

  renderGridItem = (element: GridElement) => {
    const { index, width, height, style } = element;
    const { items } = this.props;
    const item = items[index];
    const type = getItemType(item);

    return (
      item &&
      type && (
        <ItemCard
          itemIndex={index}
          key={this.getGridItemId(index)}
          type={type}
          item={item}
          width={width}
          height={height}
          style={style}
        />
      )
    );
  };

  adjustCardHeightForPageType() {
    /* eslint-disable no-fallthrough */
    /* tslint:disable no-switch-case-fall-through */
    switch (this.props.pageType) {
      case 'commissions':
        return COMMISSION_CARD_FOOTER_HEIGHT;
      case 'collections':
        return COLLECTION_CARD_FOOTER_HEIGHT;
      case 'artists':
        if (this.props.isMobile) {
          return -36;
        }
      case 'groups':
      case 'statuses':
      case 'polls':
      case 'journals':
      default:
        return 0;
    }
    /* tslint:enable no-switch-case-fall-through */
  }

  getGridItemId = (index: number) => {
    const { items } = this.props;
    const item = items[index];
    const type = getItemType(item);
    return `item-${type}-${getItemId(item)}`;
  };

  getDuperbrowseItemId = (index: number) => {
    const { items } = this.props;
    const item = items[index];

    if (isDeviation(item)) {
      return getStreamItemId(item);
    }

    const type = getItemType(item);
    return `item-${type}-${getItemId(item)}`;
  };
}

export default BrowseGrid;
